'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '../lib/cn.js';
import { usePrefersReducedMotion } from '../lib/usePrefersReducedMotion.js';
import styles from './Mascot.module.css';
const MASCOT_SRC = new URL('./mascot.png', import.meta.url).href;
export function Mascot({ pose = 'idle', size = 120, muted = false, animate = true, alt, className, }) {
    const prefersReducedMotion = usePrefersReducedMotion();
    return (_jsx("img", { src: MASCOT_SRC, alt: alt, width: size, height: size, "data-pose": pose, className: cn(styles['mascot'], muted && styles['muted'], animate && !prefersReducedMotion && styles['floaty'], className) }));
}
